import { useEffect } from 'react'
import { Star, Clock, Heart, History } from 'lucide-react'
import { usePreferences } from '../contexts/PreferencesContext'

const CameraPreferences = ({ cameras, onCameraSelect, selectedCameras }) => {
    const { preferences, toggleFavorite, addRecentCamera, isSyncing } = usePreferences()
    const favorites = preferences.favorites || []
    const recentCameras = preferences.recentCameras || []
    
    console.log('CameraPreferences - preferences:', preferences)
    console.log('CameraPreferences - favorites:', favorites)
    console.log('CameraPreferences - recentCameras:', recentCameras)

    const handleCameraClick = (camera) => {
        onCameraSelect(camera)
        addRecentCamera(camera._id)
    }

    const getFavoriteCameras = () => {
        return cameras.filter(camera => favorites.includes(camera._id))
    }

    const getRecentCameras = () => {
        return cameras.filter(camera => recentCameras.includes(camera._id))
    }

    if (isSyncing) {
        return (
            <div className="p-4 text-center text-gray-500">
                <div className="animate-spin h-6 w-6 border-b-2 border-indigo-600 mx-auto mb-2"></div>
                Syncing your preferences...
            </div>
        )
    }

    return (
        <div className="space-y-6">
            {/* Favorites Section */}
            <div>
                <div className="flex items-center space-x-2 mb-3">
                    <Heart className="h-5 w-5 text-red-500" />
                    <h3 className="text-lg font-semibold text-gray-900">Favorites</h3>
                </div>
                
                {getFavoriteCameras().length === 0 ? (
                    <div className="text-center py-6 text-gray-500">
                        <Star className="h-8 w-8 mx-auto mb-2 text-gray-300" />
                        <p>No favorite cameras yet</p>
                        <p className="text-sm">Click the star icon on any camera to add it to favorites</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-1">
                        {getFavoriteCameras().map((camera) => (
                            <div
                                key={camera._id}
                                className={`p-2 rounded-lg border cursor-pointer transition-colors ${
                                    selectedCameras.find(c => c._id === camera._id)
                                        ? 'border-indigo-500 bg-indigo-50'
                                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                                }`}
                                onClick={() => handleCameraClick(camera)}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex-1">
                                        <div className="font-medium text-gray-900">{camera.name}</div>
                                        <div className="text-sm text-gray-500">{camera.location?.city || 'No location'}</div>
                                    </div>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            toggleFavorite(camera._id)
                                        }}
                                        className="text-red-500 hover:text-red-700 p-1"
                                    >
                                        <Heart className="h-4 w-4 fill-current" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Recent Cameras Section */}
            <div>
                <div className="flex items-center space-x-2 mb-3">
                    <History className="h-5 w-5 text-blue-500" />
                    <h3 className="text-lg font-semibold text-gray-900">Recent Cameras</h3>
                </div>
                
                {getRecentCameras().length === 0 ? (
                    <div className="text-center py-6 text-gray-500">
                        <Clock className="h-8 w-8 mx-auto mb-2 text-gray-300" />
                        <p>No recent cameras</p>
                        <p className="text-sm">Your recently used cameras will appear here</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-1">
                        {getRecentCameras().map((camera) => (
                            <div
                                key={camera._id}
                                className={`p-2 rounded-lg border cursor-pointer transition-colors ${
                                    selectedCameras.find(c => c._id === camera._id)
                                        ? 'border-indigo-500 bg-indigo-50'
                                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                                }`}
                                onClick={() => handleCameraClick(camera)}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex-1">
                                        <div className="font-medium text-gray-900">{camera.name}</div>
                                        <div className="text-sm text-gray-500">{camera.location?.city || 'No location'}</div>
                                    </div>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            toggleFavorite(camera._id)
                                        }}
                                        className={`p-1 ${
                                            favorites.includes(camera._id)
                                                ? 'text-red-500 hover:text-red-700'
                                                : 'text-gray-400 hover:text-red-500'
                                        }`}
                                    >
                                        <Heart className={`h-4 w-4 ${favorites.includes(camera._id) ? 'fill-current' : ''}`} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CameraPreferences 